import styled from 'styled-components';

export const StyledMainContent = styled.div`
  min-height: inherit;
`;
